






















































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IBulkActionProvider,
  IBulkActionProviderMethods
} from "@/models/providers/bulkAction";
import getProgressAndStatus from "@/components/app/admin/automation/getProgressAndStatus";

@Component({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  }
})
export default class BulkActionDetails extends Vue {
  @Inject({ from: "bulkActionProvider" })
  public readonly $bulkActionProviderData!: () => IBulkActionProvider;

  @Inject({ from: "bulkActionProviderMethods" })
  public readonly $bulkActionProviderMethods!: () => IBulkActionProviderMethods;

  public get provider() {
    return this.$bulkActionProviderData();
  }

  public get bulkAction() {
    return this.provider.bulkAction;
  }

  public get segment() {
    return this.bulkAction.segment;
  }

  public get template() {
    return this.provider.template;
  }

  public get progressAndStatus() {
    return getProgressAndStatus(this.bulkAction);
  }
}
